import { render, staticRenderFns } from "./ClientCard.vue?vue&type=template&id=185c6679&"
import script from "./ClientCard.vue?vue&type=script&lang=js&"
export * from "./ClientCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports